module.exports = __webpack_public_path__ + "static/media/edit.612928ab.svg";